import { Component, OnInit } from '@angular/core';
import { ViewMode } from '@core/enumeration';
import { IHHOralNotification } from '@core/model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-oral-notifications-dialog',
    templateUrl: './oral-notifications-dialog.component.html',
    styleUrls: ['./oral-notifications-dialog.component.scss'],
    standalone: false
})
export class OralNotificationsDialogComponent implements OnInit {
  model: IHHOralNotification;
  mode: ViewMode = ViewMode.View;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) { }

  ngOnInit() {
    this.mode = this.config.data.mode;
    this.model = this.config.data.model;
  }

  onCancel() {
    this.ref.close(null);
  }

  onSubmit(ev: IHHOralNotification) {
    this.ref.close(ev);
  }

}
